import { Editor } from '@tinymce/tinymce-react'
import { FormControl } from 'baseui/form-control'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'

const ModalResources = ({
  isOpen,
  close,
  selectedProductType,
  resources,
  tinymceKey,
  updateResources,
  saveResources,
  isSavingResources,
}) => {
  const selectElementOfType = type => resources.find(r => r.resource_type === type)?.resource_value || ''
  const saleScript = selectElementOfType('sale_script')
  const learningLink = selectElementOfType('learning_link')
  const emailTemplateLink = selectElementOfType('email_template_link')
  const objections = selectElementOfType('objections')

  return (
    <Modal
      onClose={close}
      isOpen={isOpen}
      overrides={{
        Dialog: {
          style: {
            width: '80vw',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <ModalHeader>Edit Resources of type {selectedProductType[0]?.label}</ModalHeader>
      <ModalBody>
        <FormControl label='Lien formation'>
          <input
            type='text'
            value={learningLink}
            style={{ width: '100%' }}
            onChange={e => updateResources('learning_link', e.target.value)}
          />
        </FormControl>
        <FormControl label='Lien Email Template'>
          <input
            type='text'
            value={emailTemplateLink}
            style={{ width: '100%' }}
            onChange={e => updateResources('email_template_link', e.target.value)}
          />
        </FormControl>
        <FormControl label='Sale Script'>
          <Editor
            apiKey={tinymceKey}
            init={{
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'code',
                'wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            }}
            initialValue={saleScript}
            onChange={e => updateResources('sale_script', e.target.getContent())}
          />
        </FormControl>
        <FormControl label='objections'>
          <Editor
            apiKey={tinymceKey}
            init={{
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'code',
                'wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            }}
            initialValue={objections}
            onChange={e => updateResources('objections', e.target.getContent())}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind='tertiary' onClick={close}>
          Cancel
        </ModalButton>
        <ModalButton onClick={saveResources} isLoading={isSavingResources} kind='primary'>
          Save
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default ModalResources
